import { Hero } from "../components/home/Hero";
import { Marquee, VideoSection, ValueBento, Steps, Pillars } from "../components/home/Sections";
import { Pricing, Testimonials, Faq, DownloadCTA, ContactSection, FeaturedShop } from "../components/home/Conversion";
import { SocialProof } from "../components/home/SocialProof";
import { useSite } from "../context/SiteContext";

export default function HomePage() {
    const { data, failed } = useSite();
    if (failed) {
        return (
            <div className="min-h-screen bg-ivory text-ink flex items-center justify-center p-8 text-center" data-testid="home-load-error">
                <p>Le site rencontre une difficulté technique. Merci de réessayer dans un instant.</p>
            </div>
        );
    }
    if (!data) {
        return <div className="min-h-screen bg-ivory" data-testid="home-loading" aria-label="Chargement" />;
    }
    return (
        <main>
            <Hero />
            <Marquee />
            <VideoSection />
            <ValueBento />
            <Steps />
            <Pillars />
            <FeaturedShop />
            <Pricing />
            <SocialProof />
            <Testimonials />
            <Faq />
            <DownloadCTA />
            <ContactSection />
        </main>
    );
}
